import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { proxy } from 'valtio';
import {
  ToastState,
  ToastOptions,
  Toast,
  IncomingCallToastType,
} from './types';

export const toastsState = proxy<ToastState>({
  toasts: [],
  incomingCallToasts: [],
});

class ToastModule extends AppModule {
  /**
   * Provides an api for the application to render Anvil Toasts.
   * Toasts will be displayed in the order they are invoked.
   * With the newest toasts at the top.
   * The default duration is 8 seconds, inline with the Anvil Toast's default duration.
   * @param toast - The toast options.
   */
  public showToast(toast: ToastOptions) {
    const newToast: Toast = {
      ...toast,
      duration: toast.duration || 8000, // default duration is 8 seconds to match anvil's default duration
      createdAt: Date.now(),
    };

    // use unshift to keep the newer toasts at the top
    toastsState.toasts.unshift(newToast);
  }

  public hideToast(createdAt: number) {
    // remove toast from state
    const newToasts = [...toastsState.toasts].filter(
      (t) => t.createdAt !== createdAt,
    );
    toastsState.toasts = newToasts;
  }

  public showIncomingCallToast(callToast: IncomingCallToastType) {
    toastsState.incomingCallToasts.unshift(callToast);
  }

  public hideIncomingCallToast(sessionId: string) {
    const newCallToasts = [...toastsState.incomingCallToasts].filter(
      (t) => t.id !== sessionId,
    );
    toastsState.incomingCallToasts = newCallToasts;
  }
}

export default new ToastModule(appManager.events, appManager.logger('Toasts'));
